<template>
  <v-container fluid no-gutter class="pa-0">
    <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 10" preserveAspectRatio="none">
      <polygon points="100 0 100 10 0 10" />
    </svg> -->
  <div :class='"gradient-"+show'>
  </div>
  <!-- <div :class='"section-diagonal-"+show'>
  </div> -->
  </v-container>
</template>

<script>
export default {
  name: "SecDiagonal",
  props: {
    value: String
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  }
};
</script>

<style scoped>
.section-diagonal-bottom {
  /* position: absolute; */
  /* border-bottom: 4vw solid #FAFAF7; */
  border-bottom: 4vw solid #FFFFFF;
  /* border-left: 212vw solid transparent; */
  border-left: 212vw solid #F5F5F5;
  bottom: 0;
  z-index: 0;
}
.section-diagonal-top {
  /* position: absolute; */
  border-top: 4vw solid #FFFFFF;
  border-right: 212vw solid #F5F5F5;
  /* z-index: 0; */
}
.diagonal-top {
  display: block;
  width: 100%;
  height: 40px;
  /* background: #FAFAF7; */
  background: #FFFFFF;
}
.gradient-top {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 30px 100vw 0 0;
  border-color: #FFFFFF #F5F5F5 transparent transparent;
  transform: scale(1.0001);
}
.gradient-bottom {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 30px 100vw 0 0;
  border-color: #F5F5F5 #FFFFFF transparent transparent;
  transform: scale(1.0001);
}
</style>
